import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {connect} from 'react-redux';
import {setReportWidgetLoadingStateAndNotifyPhantom} from '../../services/redux/actions';

export default (config = {}) => (WrappedComponent) => {
  @connect()
  class EnhancedComponent extends Component {

    componentDidMount() {
      const widgetId = config.widgetIdSuffix
        ? this.props.widget.id + config.widgetIdSuffix
        : this.props.widget.id
      this.props.dispatch(
        setReportWidgetLoadingStateAndNotifyPhantom(
          this.props.report.id,
          widgetId,
          true,
        ),
      );
    }

    render() {
      return (
        <WrappedComponent {...this.props} />
      );
    }
  }

  const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  EnhancedComponent.displayName = `NotifiesPhantomWhenMounted(${wrappedComponentName})`;

  return createFragmentContainer(
    EnhancedComponent,
    graphql`
      fragment notifyPhantomWhenMounted_report on Report {
        id
        groupByLocation
      }
    `,
  );
};



// WEBPACK FOOTER //
// ./src/components/notifyPhantomWhenMounted/notifyPhantomWhenMounted.js